import React from 'react';
import { motion } from 'framer-motion';
import { Star } from 'lucide-react';
const testimonials = [{
  name: 'Martín S.',
  age: 34,
  city: 'Buenos Aires',
  text: 'Antes llegaba al club y armaba los ejercicios en el momento. Desde que uso el sistema, los pibes notaron el cambio al instante. Los entrenamientos tienen un sentido y ganamos en intensidad.'
}, {
  name: 'Diego L.',
  age: 29,
  city: 'Rosario',
  text: "Lo mejor que tiene es la estructura. Te saca ese peso de encima de pensar 'qué hago hoy'. Ya tengo todo planificado y me enfoco en corregir detalles. Totalmente recomendado."
}, {
  name: 'Federico G.',
  age: 41,
  city: 'Córdoba',
  text: 'Dirijo hace 8 años y sentía que estaba estancado. Este material me ordenó la cabeza. Las progresiones tácticas son clarísimas y fáciles de llevar a la cancha.'
}, {
  name: 'Lucas M.',
  age: 28,
  city: 'Mendoza',
  text: 'Vale cada peso. Estaba a punto de dejar de dirigir por la frustración de no ver mejoras en el equipo. Aplicar este método nos cambió la cara, empezamos a competir de verdad.'
}, {
  name: 'Alejandro P.',
  age: 37,
  city: 'La Plata',
  text: 'La organización semanal es una locura. Pasé de improvisar con conos a tener un plan de trabajo serio. Hasta los dirigentes del club me felicitaron por el cambio de actitud del equipo.'
}];
export function Testimonials() {
  return <section className="py-16 px-4 bg-gray-900 border-t border-gray-800" data-id="element-156">
      <div className="max-w-5xl mx-auto" data-id="element-157">
        <h2 className="text-2xl md:text-3xl font-bold text-center text-white mb-12" data-id="element-158">
          Entrenadores que ya dejaron de improvisar
        </h2>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-159">
          {testimonials.map((t, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.1
        }} className={`bg-gray-800 p-6 rounded-2xl border border-gray-700 ${i === 4 ? 'md:col-span-2 lg:col-span-1 lg:col-start-2' : ''}`} data-id="element-160">
              <div className="flex gap-1 mb-4" data-id="element-161">
                {[...Array(5)].map((_, j) => <Star key={j} className="w-4 h-4 fill-gold text-gold" data-id="element-162" />)}
              </div>
              <p className="text-gray-300 mb-6 text-sm md:text-base italic" data-id="element-163">
                "{t.text}"
              </p>
              <div className="flex items-center gap-3 mt-auto" data-id="element-164">
                <div className="w-10 h-10 bg-gray-700 rounded-full flex items-center justify-center font-bold text-gold border border-gray-600" data-id="element-165">
                  {t.name.charAt(0)}
                </div>
                <div data-id="element-166">
                  <p className="font-bold text-white text-sm" data-id="element-167">{t.name}</p>
                  <p className="text-xs text-gray-400" data-id="element-168">
                    {t.age} años, {t.city}
                  </p>
                </div>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}